import { render, staticRenderFns } from "./ProductMediaMobileSticky.vue?vue&type=template&id=c5611c0c&scoped=true&"
import script from "./ProductMediaMobileSticky.vue?vue&type=script&lang=js&"
export * from "./ProductMediaMobileSticky.vue?vue&type=script&lang=js&"
import style0 from "./ProductMediaMobileSticky.vue?vue&type=style&index=0&id=c5611c0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5611c0c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyVideo: require('/app/components/UI/UiLazyVideo.vue').default,UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default,UiSpinner: require('/app/components/UI/UiSpinner.vue').default,UiButton: require('/app/components/UI/UiButton.vue').default})
